import cx from 'classnames';

import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { MEMBER_BENEFITS } from '../config/catalogConfig';

const namespace = 'OtherServices';

interface MemberBenefitProps {
  partnerSlug: string;
  className?: string;
}

/**
 * Pruh „Výhoda pro uživatele eVlastníků" (config `MEMBER_BENEFITS`): vlevo velké číslo (sleva z provize)
 * nebo ikona, vpravo label + text. Divize bez výhody nic nevykreslí. Jen pro vlastníky – rozhoduje volající.
 */
export const MemberBenefit: React.FC<MemberBenefitProps> = ({ partnerSlug, className }) => {
  const benefit = MEMBER_BENEFITS[partnerSlug];
  if (!benefit) return null;

  return (
    <div className={cx('MemberBenefit', className)}>
      {benefit.figure ? (
        <span className="MemberBenefit__figure">{benefit.figure}</span>
      ) : (
        <span className="MemberBenefit__icon">
          <Icon name="badge" />
        </span>
      )}
      <div className="MemberBenefit__body">
        <Text as="div" size="body-xs" weight="600" className="MemberBenefit__label">
          {t('Benefit.label', namespace)}
        </Text>
        <Text as="p" size="body-small" weight="500" color="Neutral800">
          {benefit.text}
        </Text>
      </div>
    </div>
  );
};

export default MemberBenefit;
